// extracted by mini-css-extract-plugin
export default {"root":"WhKBUFiy0eoLFOSvQfx6"};